import React from 'react';
import './App.css';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Cases from './pages/Cases';
import PasswordGate from './components/PasswordGate';

const App = () => {
	return (
		<BrowserRouter>
			<Routes>
				<Route index element={<Home />} />
				<Route path="/about" element={<About />} />
				<Route path="/work" element={<Projects />} />
				<Route
					path="/cases"
					element={
						<PasswordGate>
							<Cases />
						</PasswordGate>
					}
				/>
			</Routes>
		</BrowserRouter>
	);
};

export default App;
